import type { Conversation, UserRole } from '@/types';
import { STORAGE_KEYS } from '@/utils/constants';

type ConversationSeed = Pick<Conversation, 'id' | 'title' | 'messageCount' | 'lastMessage' | 'createdAt' | 'updatedAt'>;

const STATIC_SEEDS_BY_ROLE: Record<UserRole, ConversationSeed[]> = {
  operator: [
    {
      id: 'op-seed-1',
      title: 'New controller onboarding',
      messageCount: 12,
      lastMessage: 'Sure — I can help you add a controller. What model is it?',
      createdAt: '2026-04-18T07:50:00.000Z',
      updatedAt: '2026-04-18T07:50:00.000Z',
    },
    {
      id: 'op-seed-2',
      title: 'Credential reissue started',
      messageCount: 6,
      lastMessage: 'I’ve queued the steps. Please confirm before we execute.',
      createdAt: '2026-04-18T06:50:00.000Z',
      updatedAt: '2026-04-18T06:50:00.000Z',
    },
    {
      id: 'op-seed-3',
      title: 'Access denied at Main entrance',
      messageCount: 9,
      lastMessage: 'Let’s check which credential was presented and its access group.',
      createdAt: '2026-04-18T06:00:00.000Z',
      updatedAt: '2026-04-18T06:00:00.000Z',
    },
  ],
  novice: [],
};

export function getStaticConversations(role: UserRole): Conversation[] {
  const userId = localStorage.getItem(STORAGE_KEYS.USER_ID) || 'demo-user';
  const userEmail = localStorage.getItem(STORAGE_KEYS.USER_EMAIL) || 'demo@local';
  const userName = localStorage.getItem(STORAGE_KEYS.USER_NAME) || 'Demo user';

  return STATIC_SEEDS_BY_ROLE[role].map((seed) => ({
    ...seed,
    userId,
    userEmail,
    userName,
  }));
}

